import { css } from "styles/styled_components";

const ellipsis = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default ellipsis;
